const Button = ({ onClick, btnText }) => {
  return (
    <button
      className="btn-primary w-full mt-6 shadow-[0_8px_16px_-4px_rgba(137,49,104,0.3)] active:shadow-none"
      onClick={onClick}
    >
      {btnText}
    </button>
  );
};

export default Button;
